export default {
  "de": {
    "access-denied": "kein-zugriff",
    "appSettings": "app-einstellungen",
    "cart": "warenkorb",
    "cartCheckout": "bestelluebersicht",
    "cartOrderThankyou": "bestellbestaetigung",
    "categories": "kategorien",
    "cross-reference": "cross-reference",
    "distributorSearch": "haendlersuche",
    "faq": "faq",
    "guides": "hilfe",
    "hydraulic-selector": "hydraulik-selektor",
    "management": "verwaltung",
    "management-addresses": "adressen",
    "management-companyinformation": "informationen-firmenkonto",
    "management-csvcatalog": "csv-katalog",
    "management-ebcsettings": "ebc-einstellungen",
    "management-productdata": "produktdaten",
    "management-users": "benutzer",
    "newcategories": "neuekategorien",
    "new-construction": "neue-konstruktion",
    "news": "nachrichten",
    "orderHistory": "bestellhistorie",
    "orders": "bestellungen",
    "products": "produkte",
    "profile": "profil",
    "register": "registrierung",
    "registerThankYou": "registrierung-danke",
    "replacement": "ersatzteil",
    "requests": "anfragen",
    "searchResults": "suchergebnisse",
    "setup": "einrichtung"
  },
  "en": {
    "access-denied": "no-access",
    "appSettings": "app-settings",
    "cart": "cart",
    "cartCheckout": "checkout",
    "cartOrderThankyou": "order-thankyou",
    "categories": "categories",
    "cross-reference": "cross-reference",
    "distributorSearch": "distributor-search",
    "faq": "faq",
    "guides": "help",
    "hydraulic-selector": "hydraulic-selector",
    "management": "management",
    "management-addresses": "addresses",
    "management-companyinformation": "company-account-information",
    "management-csvcatalog": "csv-catalog",
    "management-ebcsettings": "ebcsettings",
    "management-productdata": "productdata",
    "management-users": "users",
    "newcategories": "newcategories",
    "new-construction": "new-construction",
    "news": "news",
    "orderHistory": "order-history",
    "orders": "orders",
    "products": "products",
    "profile": "profile",
    "register": "register",
    "registerThankYou": "register-thankyou",
    "replacement": "replacement",
    "requests": "requests",
    "searchResults": "search-results",
    "setup": "setup"
  },
  "es": {
    "access-denied": "sin-acceso",
    "appSettings": "configuración",
    "cart": "carrito",
    "cartCheckout": "Resumen del pedido",
    "cartOrderThankyou": "pedido-gracias",
    "categories": "categorias",
    "cross-reference": "referencia-cruzada",
    "distributorSearch": "búsqueda-distribuidores",
    "faq": "PP. FF.",
    "guides": "ayuda",
    "hydraulic-selector": "hidraulico-selector",
    "management": "administración",
    "management-addresses": "direcciones",
    "management-companyinformation": "información-sobre-cuenta-de-empresa",
    "management-csvcatalog": "catálogo-csv",
    "management-ebcsettings": "configuración-ebc",
    "management-productdata": "datos-producto",
    "management-users": "usuarios",
    "newcategories": "newcategorias",
    "new-construction": "nueva-construccion",
    "news": "novedades",
    "orderHistory": "historial-pedidos",
    "orders": "pedidos",
    "products": "productos",
    "profile": "perfil",
    "register": "registrarse",
    "registerThankYou": "registrarse-gracias",
    "replacement": "sustitucion",
    "requests": "solicitudes",
    "searchResults": "resultados-búsqueda",
    "setup": "instalación"
  },
  "fr": {
    "access-denied": "pas-d'accès",
    "appSettings": "parametres-l-application",
    "cart": "panier",
    "cartCheckout": "récapitulatif-commande",
    "cartOrderThankyou": "confirmation-commande",
    "categories": "categories",
    "cross-reference": "reference-croisee",
    "distributorSearch": "recherche-distributeurs",
    "faq": "faq",
    "guides": "aide",
    "hydraulic-selector": "selecteur-hydraulique",
    "management": "administration",
    "management-addresses": "adresses",
    "management-companyinformation": "informations-compte-société",
    "management-csvcatalog": "csv-catalogue",
    "management-ebcsettings": "paramètres-ebc",
    "management-productdata": "données-produit",
    "management-users": "utilisateurs",
    "newcategories": "newcategories",
    "new-construction": "nouvelle-construction",
    "news": "actualités",
    "orderHistory": "historique-commande",
    "orders": "commandes",
    "products": "produits",
    "profile": "profil",
    "register": "enregistrement",
    "registerThankYou": "enregistrement-merci",
    "replacement": "remplacement",
    "requests": "demandes-de-prix",
    "searchResults": "resultats-recherche",
    "setup": "configuration"
  },
  "it": {
    "access-denied": "nessun-accesso",
    "appSettings": "impostazioni-dell-app",
    "cart": "carrello",
    "cartCheckout": "panoramica-dell'ordine",
    "cartOrderThankyou": "conferma-dell'ordine",
    "categories": "categorie",
    "cross-reference": "rimando",
    "distributorSearch": "cerca-distributore",
    "faq": "faq",
    "guides": "aiuto",
    "hydraulic-selector": "selettore-idraulico",
    "management": "gestione",
    "management-addresses": "indirizzi",
    "management-companyinformation": "informazioni-account-aziendale",
    "management-csvcatalog": "csv-catalogare",
    "management-ebcsettings": "Impostazioni-ebc",
    "management-productdata": "dati-prodotto",
    "management-users": "utenti",
    "newcategories": "newcategorie",
    "new-construction": "nuova-costruzione",
    "news": "novità",
    "orderHistory": "cronologia-ordini",
    "orders": "ordini",
    "products": "prodotto",
    "profile": "profilo",
    "register": "registrazione",
    "registerThankYou": "registrazione-grazie",
    "replacement": "sostituzione",
    "requests": "richieste",
    "searchResults": "risultati-ricerca",
    "setup": "impostazione"
  }
}